type TOrderStatus = {
    crm_id: number;
    order_id: number;
    status_id: number;
    comment?: number;
    relation_type?: 'orderProduct' | 'orderService' | 'orderTask';
    relation_id?: number;
};

export enum StatusTypesEnum {
    // Создание заказа
    ORDER_CREATE = 'orderCreate',
    // На согласовании
    UNDER_APPROVAL = 'underApproval',
    // Согласовано
    APPROVED = 'approved',
    // Задержка старта
    START_DELAY = 'startDelay',
    // Отменен
    CANCELED = 'canceled',
    // В работе
    IN_PROGRESS = 'inProgress',
    // Ожидание
    WAITING = 'waiting',
    // Задержка завершения
    DELAY_COMPLETION = 'delayCompletion',
    // Ожидает оплаты
    AWAITING_PAYMENTS = 'awaitingPayments',
    // Завершен
    COMPLETED = 'completedOrder',
}

type TOrderStatusType = {
    id: number;
    // Порядок от 1
    order: number;
    // Видимое название
    name: string;
    // Цвет обводки в hex-формате
    color: string;
    // Тип статуса
    type?: StatusTypesEnum;
};

export type { TOrderStatus, TOrderStatusType };
